import {
  ActionButtonOutcomesType,
  APP_ZONES,
  BaseWidgetProperties,
  ConfirmationClaimType,
} from '@finxone-platform/shared/sys-config-types';

import { Injector } from '@angular/core';
import { ConfigService } from '../../../services/config-service/config-service.service';
import { ConfirmationService } from '../../../services/confirmation-service/confirmation-service';
import { buildActionNavigationTargetUrl } from '../cta-redirection.utils';

/**
 * Navigates to a confirmation code page for displaying an ePIN.
 *
 * This utility function checks if a modal redirection is required for the
 * CARD_MANAGEMENT_ZONE using the provided ConfigService. If a target URL is
 * determined, it navigates the Router to the 'confirmation-code' route with
 * specific query parameters for ePIN retrieval.
 *
 * @param router - The Angular Router instance used for navigation.
 * @param configService - The ConfigService instance used to determine the
 *                        target URL for redirection.
 */
export const showEPINUtil = (injector: Injector, widgetProperties: BaseWidgetProperties) => {
  const confirmationService = injector.get(ConfirmationService);
  const configService = injector.get(ConfigService);
  // Build the success and failure navigation URLs based on widget properties and configuration

  const actionNavigationTargetUrl = buildActionNavigationTargetUrl(
    widgetProperties,
    injector,
    ActionButtonOutcomesType.SUCCESS,
  );

  const actionNavigationFailureUrl = buildActionNavigationTargetUrl(
    widgetProperties,
    injector,
    ActionButtonOutcomesType.FAILURE,
  );

  // Determine the target URL for redirection, prioritizing the action navigation target URL
  const targetUrl =
    actionNavigationTargetUrl || configService.reRouteIfModal(APP_ZONES.CARD_MANAGEMENT_ZONE, 'show-pin');

  if (targetUrl) {
    confirmationService.confirmAction(
      ConfirmationClaimType.GET_EPIN,
      targetUrl,
      true,
      undefined,
      undefined,
      undefined,
      actionNavigationFailureUrl,
    );
  }
};

export const showPINUtil = (injector: Injector, widgetProperties: BaseWidgetProperties) => {
  const confirmationService = injector.get(ConfirmationService);
  const configService = injector.get(ConfigService);
  // Build the success and failure navigation URLs based on widget properties and configuration

  const actionNavigationTargetUrl = buildActionNavigationTargetUrl(
    widgetProperties,
    injector,
    ActionButtonOutcomesType.SUCCESS,
  );

  const actionNavigationFailureUrl = buildActionNavigationTargetUrl(
    widgetProperties,
    injector,
    ActionButtonOutcomesType.FAILURE,
  );

  // Determine the target URL for redirection, prioritizing the action navigation target URL
  const targetUrl =
    actionNavigationTargetUrl || configService.reRouteIfModal(APP_ZONES.CARD_MANAGEMENT_ZONE, 'show-pin');

  if (targetUrl) {
    confirmationService.confirmAction(
      ConfirmationClaimType.GET_PIN,
      targetUrl,
      true,
      undefined,
      undefined,
      undefined,
      actionNavigationFailureUrl,
    );
  }
};
